/** Máscara BR: (92) 99618-6635 (celular) ou (92) 3618-6635 (fixo). Aceita DDI 55 colado. */
export function maskWhatsapp(raw: string): string {
  let d = (raw || '').replace(/\D/g, '')
  if (d.length > 11 && d.startsWith('55')) d = d.slice(2)
  d = d.slice(0, 11)
  if (d.length <= 2) return d.length ? `(${d}` : ''
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`
}

/**
 * Converte o `wa.me/<n>?text=...` do servidor num link que abre direto no WhatsApp Web
 * (computador), sem a página intermediária. No celular mantém o wa.me (abre o app).
 */
export function whatsappOpenUrl(waMeUrl: string): string {
  if (/Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent)) return waMeUrl
  try {
    const u = new URL(waMeUrl)
    const phone = u.pathname.replace(/\D/g, '')
    const text = u.searchParams.get('text') || ''
    if (!phone) return waMeUrl
    return `https://web.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(text)}`
  } catch {
    return waMeUrl
  }
}

/** Nome fixo da aba: todos os envios reaproveitam a mesma aba do WhatsApp. */
export const WHATSAPP_TAB_TARGET = 'fiesta-whatsapp'

/** True se vazio ou com 10–15 dígitos. */
export function whatsappValido(raw: string): boolean {
  const d = (raw || '').replace(/\D/g, '')
  return !d || (d.length >= 10 && d.length <= 15)
}
